import { createRoot } from "react-dom/client";
import { Toaster } from "react-hot-toast";

import { lazy } from "react";

import { APP_NAMES } from "./constants/common.constants";
import { getAppNameByPathName } from "./utils/common";

import "./index.css";

const BeaverBackoffice = lazy(
  () => import("./beaverBackoffice/components/App"),
);
const BeaverWebsite = lazy(() => import("./beaver/components/App"));
const Clarity = lazy(() => import("./clarity/components/App"));
const CommercialWebsite = lazy(
  () => import("./commercialWebsite/components/App"),
);
const PhotoAlbum = lazy(() => import("./photoAlbum/components/App"));
const PhotoAlbum2 = lazy(() => import("./photoAlbum2/components/App"));
const TenantForm = lazy(() => import("./tenantForm/components/App"));
const ToyRecommendations = lazy(
  () => import("./toyRecommendation/components/App"),
);
const FinancialDashboard = lazy(
  () => import("./financialDashboard/components/App"),
);
const TimeOwner = lazy(() => import("./timeOwner/components/App"));
const Mashmauti = lazy(() => import("./mashmauti/components/App"));
const MashmautiCommercial = lazy(
  () => import("./mashmauti-commercial/components/App"),
);
const Payless = lazy(() => import("./payless/components/App"));
const Unsupported = () => <h1>Unsupported</h1>;

const appByPaths = {
  [APP_NAMES.BEAVER]: BeaverWebsite,
  [APP_NAMES.BEAVER_BACKOFFICE]: BeaverBackoffice,
  [APP_NAMES.CLARITY]: Clarity,
  [APP_NAMES.COMMERCIAL_WEBSITE]: CommercialWebsite,
  [APP_NAMES.PHOTO_ALBUM]: PhotoAlbum,
  [APP_NAMES.PHOTO_ALBUM2]: PhotoAlbum2,
  [APP_NAMES.TENANT_FORM]: TenantForm,
  [APP_NAMES.TOY_RECOMMENDATIONS]: ToyRecommendations,
  [APP_NAMES.FINANCIAL_DASHBOARD]: FinancialDashboard,
  [APP_NAMES.TIME_OWNER]: TimeOwner,
  [APP_NAMES.MASHMAUTI]: Mashmauti,
  [APP_NAMES.MASHMAUTI_COMMERCIAL]: MashmautiCommercial,
  [APP_NAMES.PAYLESS]: Payless,
};

const requestedApp = getAppNameByPathName(window.location.pathname);

const RequestedApp = appByPaths[requestedApp] || Unsupported;

const container = document.getElementById("app");
const root = createRoot(container);
root.render(
  <>
    <RequestedApp />
    <Toaster />
  </>,
);
